import { Role } from "@xanadu/model";
import { DataService } from "../../service/data/data.service";
import { DataCache } from "./data.cache";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class RoleCache extends DataCache<Role> {

    constructor(
        dataService: DataService
    ) {
        super(Role, dataService);
    }
}
